import { render, staticRenderFns } from "./ActualizacionEstudiantes.vue?vue&type=template&id=8c1d7c80&scoped=true"
import script from "./ActualizacionEstudiantes.vue?vue&type=script&lang=js"
export * from "./ActualizacionEstudiantes.vue?vue&type=script&lang=js"
import style0 from "./ActualizacionEstudiantes.vue?vue&type=style&index=0&id=8c1d7c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1d7c80",
  null
  
)

export default component.exports